import { preventLoad } from "./blockers";
// NOTE(liamvdv): we must inline the module preload polyfill, which applies the 'base'-path to absolute path import files.
// https://vite.dev/config/build-options.html#build-modulepreload
// Required for manual exports, else will
//      import {_ as o} from ./modulepreload-polyfill-xxxxx.js
// which fails on non chat.botbrains.io domains (files not hosted at somecustomer.com/modulepreload-polyfill-xxxxx.js)
import "vite/modulepreload-polyfill";

if (!preventLoad()) {
  import("./embed").catch(console.error);
}
